module.exports = __webpack_public_path__ + "img/tentaculo-g.3fce4f8c.png";